import md5 from 'js-md5'

const mbUrl = {}

mbUrl.getServer = () => {
    let server = ''
    switch(mbUrl.getEnvironment()) {
        case 'development':
        case 'staging':
            server = 'mystaging'
            break
        case 'production':
            server = 'my'
            break
        default:
            server = 'mystaging'
    }

    return 'https://' + server + '.meteoblue.com'
}

mbUrl.getEnvironment = () => {
    if (typeof mb !== 'undefined'
        && typeof mb.settings !== 'undefined'
        && typeof mb.settings.environment !== 'undefined')
    {
        return mb.settings.environment
    } else {
        return 'development'
    }
}

mbUrl.getSigned = (path, params, options = {}) => {

    if(typeof params === 'undefined') {
        params = false
    }

    if(typeof options.postBody === 'undefined') {
        options.postBody = false
    }

    if(typeof options.server === 'undefined') {
        options.server = mbUrl.getServer()
    }

    const hasGlobalSettings = typeof mb !== 'undefined' && typeof mb.settings !== 'undefined'

    if(!hasGlobalSettings) {
        throw Error('Global settings object "mb.settings" is missing.')
    }

    if(hasGlobalSettings && typeof mb.settings.apiKey === 'undefined' ) {
        throw Error('Property "apiKey" in "mb.settings" is missing.')
    }

    if(hasGlobalSettings && typeof mb.settings.sharedSecret === 'undefined' ) {
        throw Error('Property "sharedSecret" in "mb.settings" is missing.')
    }

    const apiKey = mb.settings.apiKey

    const sharedSecret = atob(mb.settings.sharedSecret)

    const queryString = path
        + '?apikey=' + apiKey
        + (params ? '&' + params : '')
        + (options.postBody ? '&post_body_md5=' + md5(options.postBody) : '')
        + '&ts=' + (Date.now() / 1000).toFixed(0)

    const url = options.server
        + queryString
        + '&sig=' + md5(queryString + '&secret=' + sharedSecret)

    return url
}

export default mbUrl